<template>
  <div class="login h-100">
        <div class="head ml-5">
          <a href="/" class="logo" @click.prevent="reset">
            <img src="@/assets/logo.png" />
          </a>
          <!-- <p class="subtitle mt-4">{{ $t("notRegisteredYet") }}</p> -->
          <!-- <router-link
            :to="`/register?id_number=${id_number}`"
            class="register-btn"
          >
            {{ $t("register") }}
          </router-link> -->
          <!-- <div class="mt-3">
            <p class="subtitle mt-4">{{ $t("orFindOutMore") }}</p>
            <router-link to="/" class="px-2 mx-2 pt-1 svg-sm d-inline-block svg-upper">
              <InfoIcon></InfoIcon>
              <small class="pl-1 uppercase">{{ $t("home") }}</small>
            </router-link>
            <router-link to="/doctors" class="px-2 mx-2 pt-1 svg-sm d-inline-block svg-upper">
              <DoctorIcon></DoctorIcon>
              <small class="pl-1 uppercase">{{ $t("doctors") }}</small>
            </router-link>
            <router-link to="/services" class="px-2 mx-2 pt-1 svg-sm d-inline-block svg-upper">
              <DiagnosticsIcon></DiagnosticsIcon>
              <small class="pl-1 uppercase">{{ $t("services") }}</small>
            </router-lin'./sitemap/paths.json'
k>
          </div> -->
        </div>

        <div class="foot bg-white">
          <div v-if="!authType" class="ml-5 auth-form mb-5 scrollto">
            <div class="alert alert-warning" v-if="usernameError">
              <p>{{ $t("usernameError") }}</p>
              {{ $t("notRegisteredYet") }}
              <router-link
                :to="`/register?identifier=${identifier}`"
                class="register-btn"
              >
                {{ $t("register") }}
              </router-link>
            </div>
            <form @submit.prevent="submitUsername">
              <div class="myfield w-100 mb-4">
                <div class="alert alert-danger" v-if="err">{{ err }}</div>
                <input
                  type="text"
                  id="identifier"
                  v-model="identifier"
                  autofocus
                  @keyup.enter="submitUsername"
                />
                <label for="identifier">{{ $t("identifier") }}</label>
              </div>
              <button
                type="submit"
                class="btn btn-block auth-btn p-3"
                @click="submitUsername"
                :disabled="loading || !identifier"
              >
                {{ $t("next") }}
                <login-icon></login-icon>
              </button>
            </form>
          </div>
          <div v-else>
            <div
              v-if="authTypePassword && authType === 'Password'"
              class="auth-form ml-5 scrollto"
            >
              <form @submit.prevent="submitPassword">
                <div class="myfield w-100 mb-4">
                  <div class="alert alert-danger" v-if="err">{{ err }}</div>
                  <input
                    type="password"
                    id="password"
                    ref="password"
                    v-model="password"
                    placeholder=""
                    autofocus
                    @keyup.enter="submitPassword"
                  />
                  <label for="password">{{ $t("labelPassword") }}</label>
                </div>
                <button
                  class="btn btn-block auth-btn p-3"
                  type="submit"
                  :disabled="loading"
                  @click="submitPassword"
                >
                  {{ $t("authenticate") }}
                  <login-icon></login-icon>
                </button>
              </form>
            </div>
            <div
              v-else-if="authTypePhone && authType === 'Phone'"
              class="auth-form ml-5 scrollto"
            >
              <form @submit.prevent="submitPhone">
                <div class="myfield w-100 mb-4">
                  <div class="alert alert-danger" v-if="err">{{ err }}</div>
                  <input
                    type="number"
                    id="phone"
                    v-model="phone"
                    placeholder=""
                    autofocus
                    @keyup.enter="submitPhone"
                  />
                  <label for="phone">{{ $t(`labelPhoneCode`) }}</label>
                </div>
                <button
                  class="btn btn-block auth-btn p-3"
                  type="submit"
                  :disabled="loading"
                  @click="submitPhone"
                >
                  {{ $t("authenticate") }}
                  <login-icon></login-icon>
                </button>
              </form>
              <a
                class="btn btn-block auth-btn-retry p-3"
                :disabled="loading"
                @click.prevent="setAuthType('Phone')"
              >
                {{ $t("sendCodeAgain") }}
                <retry-icon></retry-icon>
              </a>
            </div>
            <div
              v-else-if="authTypeEmail && authType === 'Email'"
              class="auth-form ml-5 scrollto"
            >
              <form @submit.prevent="submitPhone">
                <div class="myfield w-100 mb-4">
                  <div class="alert alert-danger" v-if="err">{{ err }}</div>
                  <input
                    type="number"
                    id="email"
                    v-model="email"
                    placeholder=""
                    autofocus
                    @keyup.enter="submitPhone"
                  />
                  <label for="email">{{ $t(`labelEmailCode`) }}</label>
                </div>
                <button
                  class="btn btn-block auth-btn p-3"
                  type="submit"
                  :disabled="loading"
                  @click="submitPhone"
                >
                  {{ $t("authenticate") }}
                  <login-icon></login-icon>
                </button>
              </form>
              <a
                class="btn btn-block auth-btn-retry p-3"
                :disabled="loading"
                @click.prevent="setAuthType('Email')"
              >
                {{ $t("sendCodeAgain") }}
                <retry-icon></retry-icon>
              </a>
            </div>
            <div class="alternate-step mb-5 ml-5">
              <a
                class="btn btn-block auth-type-btn p-3"
                :disabled="loading"
                v-if="authTypePassword && authType !== 'Password'"
                @click.prevent="setAuthType('Password')"
              >
                {{ $t("Password") }}
                <login-icon></login-icon>
              </a>
              <a
                class="btn btn-block auth-type-btn p-3"
                :disabled="loading"
                v-if="authTypePhone && authType !== 'Phone'"
                @click.prevent="setAuthType('Phone')"
              >
                {{ $t("PhoneCode") }}
                <login-icon></login-icon>
              </a>
              <a
                class="btn btn-block auth-type-btn p-3"
                :disabled="loading"
                v-if="authTypeEmail && authType !== 'Email'"
                @click.prevent="setAuthType('Email')"
              >
                {{ $t("EmailCode") }}
                <login-icon></login-icon>
              </a>
            </div>
          </div>
        </div>
  </div>
</template>
<script>
import LoginIcon from '@/components/Icons/Login'
import RetryIcon from '@/components/Icons/Retry'
// import InfoIcon from '@/components/Icons/Info'
// import DoctorIcon from '@/components/Icons/Doctor'
// import DiagnosticsIcon from '@/components/Icons/Diagnostics'
import { mapMutations } from 'vuex'
export default {
  name: 'Login',
  components: {
    LoginIcon,
    RetryIcon
    // InfoIcon,
    // DoctorIcon,
    // DiagnosticsIcon
  },
  metaInfo: {
    title: 'Login'
  },
  data () {
    return {
      identifier: '',
      err: null,
      usernameError: false,
      loading: false,
      authType: null,
      authTypePassword: false,
      authTypePhone: false,
      authTypeEmail: false,
      password: null,
      phone: null,
      email: null
    }
  },
  mounted () {
    if (this.$route.query.identifier) {
      this.identifier = this.$route.query.identifier
      // this.authType = 'Phone'
      // this.authTypePhone = true
      this.submitUsername()
    }
    // const inputs = this.$refs.scroller.getElementsByTagName('input')
    // for (const input of inputs) {
    //   if (input.closest('.scrollto')) {
    //     input.addEventListener('focus', () => {
    //       setTimeout(() => {
    //         this.$refs.scroller.scrollTo(
    //           0,
    //           input.closest('.scrollto').offsetTop
    //         )
    //       }, 500)
    //     })
    //   }
    // }
  },
  methods: {
    ...mapMutations({
      setToken: 'auth/setToken',
      setUser: 'auth/setUser',
      setError: 'alert/setError'
    }),
    reset () {
      this.identifier = ''
      this.err = null
      this.loading = false
      this.authTypePassword = false
      this.authTypePhone = false
      this.authTypeEmail = false
      this.authType = null
      this.password = null
      this.phone = null
      this.email = null
    },
    async submitUsername () {
      if (!this.identifier.trim()) {
        return
      }
      this.err = null
      this.loading = true
      this.authTypePassword = false
      this.authTypePhone = false
      this.authTypeEmail = false
      this.authType = null
      this.password = null
      this.phone = null
      this.email = null
      this.errors = {}
      try {
        const response = await this.axios.post('/api/auth/login', {
          identifier: this.identifier
        })
        this.loading = false
        for (const t of response.data.data) {
          if (t === 'Password') {
            this.authTypePassword = true
            setTimeout(() => {
              this.$refs.password.focus()
            }, 500)
          } else if (t === 'EmailCode') {
            this.authTypeEmail = true
          } else if (t === 'PhoneCode') {
            this.authTypePhone = true
          }
        }
        if (this.authTypePassword) {
          this.setAuthType('Password')
        } else if (this.authTypePhone) {
          this.setAuthType('Phone')
        } else if (this.authTypeEmail) {
          this.setAuthType('Email')
        }
      } catch (err) {
        this.loading = false
        if (err.response.status === 422) {
          // this.usernameError = true
          const store = window.localStorage
          store.setItem('identifier', this.identifier)
          this.$router.push({ name: 'Register' })
        }
        // this.setError(err)
      }
    },
    async submitPhone () {
      this.err = null
      this.loading = true
      try {
        const response = await this.axios.post(
          '/api/auth/login-with-phone/submit',
          {
            identifier: this.identifier,
            code: this.phone
          }
        )
        this.$store.commit('auth/setToken', response.data.data.token)
        this.$store.commit('auth/setUser', response.data.data.user)
        const session = JSON.stringify({
          token: response.data.data.token,
          user: response.data.data.user
        })
        this.$cookie.set('session', session, { expires: '1M' })
        this.loading = false
        this.authed()
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    async submitEmail () {
      this.err = null
      this.loading = true
      try {
        const response = await this.axios.post(
          '/api/auth/login-with-phone/submit',
          {
            identifier: this.identifier,
            code: this.email
          }
        )
        this.$store.commit('auth/setToken', response.data.data.token)
        this.$store.commit('auth/setUser', response.data.data.user)
        const session = JSON.stringify({
          token: response.data.data.token,
          user: response.data.data.user
        })
        this.$cookie.set('session', session, { expires: '1M' })
        this.loading = false
        this.authed()
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    async submitPassword () {
      this.err = null
      this.loading = true
      try {
        const response = await this.axios.post(
          '/api/auth/login-with-password',
          {
            identifier: this.identifier,
            password: this.password
          }
        )
        this.$store.commit('auth/setToken', response.data.data.token)
        this.$store.commit('auth/setUser', response.data.data.user)
        console.log(response.data);
        const session = JSON.stringify({
          token: response.data.data.token,
          user: response.data.data.user
        })
        this.$cookie.set('session', session, { expires: '1M' })
        this.loading = false
        this.authed()
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    async authed () {
      const interview = this.$cookie.get('interview')
      if (interview) {
        try {
          await this.axios.post(
          `/api/interviews/${interview}/bind-patient`
          )
        } catch (err) {
          this.setError(err)
        }
      }
      let redir = this.$store.getters['auth/redirect']
      if (!redir) {
        redir = { name: 'Dashboard' }
      }
      this.$router.push(redir)
    },
    async setAuthType (t) {
      this.authType = t
      this.err = null
      this.loading = true
      if (t === 'Phone') {
        try {
          await this.axios.post('/api/auth/login-with-phone/request', {
            identifier: this.identifier
          })
          this.loading = false
        } catch (err) {
          this.err = err.response.data.errors
          this.loading = false
        }
      } else if (t === 'Email') {
        try {
          await this.axios.post('/api/auth/login-with-email/request', {
            identifier: this.identifier
          })
          this.loading = false
        } catch (err) {
          this.err = err.response.data.errors
          this.loading = false
        }
      } else {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss">
.login {
  position: relative;
  .head {
    position: absolute;
    top: 3rem;
    .logo {
      display: block;
      padding: 12px;
      width: 84px;
      height: 84px;
      -webkit-border-radius: 21px;
      -moz-border-radius: 21px;
      border-radius: 21px;
      -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.15);
      -moz-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.15);
      box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.15);
      background-color: #fff;
      img {
        width: 100%;
      }
    }
    .subtitle {
      margin-bottom: 6px;
      font-family: SFProText, Helvetica;
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.08;
      color: #919aa3;
    }
    .register-btn {
      font-size: 17px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      // color: #3a3d43;
    }
  }
  .foot {
    position: absolute;
    bottom: 0;
    width: 100%;
    .auth-form {
      .auth-btn {
        display: flex;
        color: #fff;
        background-image: linear-gradient(101deg, #4295ee, #3573b7);
        justify-content: space-between;
        svg {
          width: 24px;
          height: 24px;
        }
      }
      .auth-btn-retry {
        display: flex;
        justify-content: space-between;
        svg {
          width: 24px;
          height: 24px;
        }
      }
    }
    .alternate-step {
      .auth-type-btn {
        margin: 0;
        border-top: 1px solid #e3e3e3;
        display: flex;
        justify-content: space-between;
        &:hover {
          background-color: #eee;
        }
        svg {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "notRegisteredYet": "ჯერ არ ხარ დარეგისტრირებული?",
      "register": "დარეგისტრირდი",
      "identifier": "მომხმარებლის სახელი",
      "authenticate": "ავტორიზაცია",
      "next": "შემდეგი",
      "Password": "პაროლით ავტორიზაცია",
      "EmailCode": "ელ-ფოსტით ავტორიზაცია",
      "PhoneCode": "მესიჯით ავტორიზაცია",
      "labelPassword": "პაროლი",
      "labelEmailCode": "კოდი",
      "labelPhoneCode": "კოდი",
      "sendCodeAgain": "ხელახლა გაგზავნა",
      "usernameError": "პირადი ნომერი არ მოიძებნა",
      "home": "მთავარი",
      "doctors": "ექიმები",
      "services": "სერვისები",
      "orFindOutMore": "გაიგე მეტი"
  },
  "en": {
      "notRegisteredYet": "Not registered yet?",
      "register": "Register",
      "identifier": "username",
      "authenticate": "Authenticate",
      "next": "Next",
      "Password": "Authenticate using Passowrd",
      "EmailCode": "Authenticate using E-mail",
      "PhoneCode": "Authenticate using SMS",
      "labelPassword": "Passowrd",
      "labelEmailCode": "Code",
      "labelPhoneCode": "Code",
      "sendCodeAgain": "Send Again",
      "usernameError": "ID not Found",
      "home": "Home",
      "doctors": "Doctors",
      "services": "Services",
      "orFindOutMore": "Find out more"
  }
}
</i18n>
